import { render, staticRenderFns } from "./zhlan.vue?vue&type=template&id=c0f82362&scoped=true"
import script from "./zhlan.vue?vue&type=script&lang=js"
export * from "./zhlan.vue?vue&type=script&lang=js"
import style0 from "./zhlan.vue?vue&type=style&index=0&id=c0f82362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f82362",
  null
  
)

export default component.exports